import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";

import user from "./user";
import modules from "./modules";
import lessons from "./lessons";
import forum from "./forum";
import courses from "./courses";
import releases from "./releases";
import quiz from "./quiz";
import agent from "./agent";
import ebookReader from "./ebookReader";
import term from "./term";
import community from "./community";
import telegram from "./telegram";
import portal from "./portal";
import refundRequests from "./refundRequests";

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  state,
  getters,
  mutations,
  modules: {
    user,
    modules,
    lessons,
    forum,
    courses,
    quiz,
    releases,
    agent,
    ebookReader,
    term,
    community,
    telegram,
    portal,
    refundRequests
  }
});
